
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.803 2.197A7.451 7.451 0 007.5 0C5.497 0 3.613.78 2.197 2.197A7.451 7.451 0 000 7.5c0 2.003.78 3.887 2.197 5.303A7.45 7.45 0 007.5 15a7.45 7.45 0 005.303-2.197A7.45 7.45 0 0015 7.5a7.45 7.45 0 00-2.197-5.303zM7.5 14.12a6.606 6.606 0 01-4.935-2.212A5.275 5.275 0 017.5 8.496a2.637 2.637 0 110-5.273 2.637 2.637 0 010 5.273 5.275 5.275 0 014.935 3.413A6.606 6.606 0 017.5 14.12z"}})])
          )
        }
      }
    